const {
    TARGET_PAGE,
    queueDataLayerEvents,
} = require('./analytics/navigationEventQueue');
const {pushDataLayerEvent} = require('./analytics/dataLayer');

function trackEvent(eventData) {
    return pushDataLayerEvent(eventData, {
        source: 'ecommerce_gtag',
    });
}

$(function () {
    $(document).on('lazyLoadCompleteLoaded', function () {
        trackViewItemlist();
    });
});

function trackSubProductSelection() {
    let selectedSubProductId = $('#subservice_id').val();
    let selectedSubProduct = getCurrentSubproduct(selectedSubProductId);
    let formData = getServiceFormData();
    let peopleQuantity = parseFloat(formData['people_quantity_adult']) + parseFloat(formData['people_quantity_youth']) + parseFloat(formData['people_quantity_children']);
    let fbContents = [{
        'id': selectedSubProduct.service_code,
        'quantity': peopleQuantity
    }];

    let totalPrice = $('#totalPrice').text().trim().replace('EUR', '').replace('PLN', '').replace(',', '.').trim();
    trackEvent({
        'event': 'select_item',
        'ecommerce': {
            'items': [{
                affiliation: 'krakowdirect.com',
                item_brand: 'KD-WWW',
                item_id: selectedSubProduct.service_code,
                item_name: selectedSubProduct.name,
                item_variant: selectedSubProduct.name_translated,
                item_category: selectedSubProduct.service_type,
                item_category2: formData['pickup_type'],
                item_category3: formData['tour_date'],
                item_category4: formData['private_or_group'],
                item_category5: formData['tour_lang'],
                item_list_id: "service_id_" + selectedSubProduct.parent_service_id,
                item_list_name: selectedSubProduct.name,
                price: totalPrice,
                quantity: peopleQuantity,
            }],
            'value': totalPrice,
            'currency': currentCurrency,
            'fb-x-contents': fbContents,
            'fb-x-contents-string': JSON.stringify(fbContents)
        }
    })
}

function createAddToCartEvent(orderData) {
    let orderPrice = currentCurrency === 'PLN' ? orderData.price_pln : orderData.price_eur;
    let fbContents = [{
        'id': orderData.service_id,
        'quantity': 1
    }];

    return {
        'event': 'add_to_cart',
        'ecommerce': {
            'items': [{
                'item_id': orderData.service_id,
                'item_name': orderData.service_name,
                'affiliation': 'krakowdirect.com',
                'currency': currentCurrency,
                'discount': 0,
                'index': 1,
                'item_brand': 'KD-WWW',
                'item_category': orderData.service_type,
                'item_category2': orderData.people_quantity,
                'item_category3': orderData.pick_up_type,
                'item_category4': orderData.date,
                'item_category5': orderData.language,
                'item_category6': orderData.private_or_group,
                'item_variant': 1,
                'price': orderPrice,
                'quantity': 1
            }],
            'fb-x-contents': fbContents,
            'fb-x-contents-string': JSON.stringify(fbContents),
            'value': orderPrice,
            'currency': currentCurrency,
        }
    };
}

function trackAddToCart(orderData) {
    trackEvent(createAddToCartEvent(orderData));
}

function queueAddToCart(orderData) {
    return queueDataLayerEvents(
        createAddToCartEvent(orderData),
        TARGET_PAGE.CART
    );
}

function trackViewItem(serviceId) {
    let selectedSubProduct = getCurrentSubproduct(serviceId);
    let formData = getServiceFormData();
    let peopleQuantity = parseFloat(formData['people_quantity_adult']) + parseFloat(formData['people_quantity_youth']) + parseFloat(formData['people_quantity_children']);

    trackEvent({
        'event': 'view_item',
        'ecommerce': {
            'items': [
                {
                    affiliation: 'krakowdirect.com',
                    item_brand: 'KD-WWW',
                    item_id: selectedSubProduct.service_code,
                    item_name: selectedSubProduct.name,
                    item_variant: selectedSubProduct.name_translated,
                    item_category: selectedSubProduct.service_type,
                    item_category2: formData['pickup_type'],
                    item_category3: formData['tour_date'],
                    item_category4: formData['private_or_group'],
                    item_category5: formData['tour_lang'],
                    item_list_id: "service_id_" + selectedSubProduct.parent_service_id,
                    item_list_name: selectedSubProduct.name,
                    price: $('#totalPrice').text().trim(),
                    quantity: peopleQuantity,
                }
            ]
        }
    })
}

function trackViewItemlist() {
    if (typeof (servicesList) === 'undefined' || typeof (servicesListType) === 'undefined') {
        return;
    }

    let ecommerceItems = [];
    servicesList.forEach(function (service) {
        ecommerceItems.push({
            item_id: service.api_key,
            item_name: service.title,
            affiliation: "krakowdirect.com",
            item_brand: "KD-WWW",
            item_category: service.service_template,
            item_category2: service.private_or_group,
            price: 'FROM ' + service.price_from,
        })
    });

    trackEvent({
        'event': 'view_item_list',
        'ecommerce': {
            item_list_id: servicesListType + "_list",
            item_list_name: servicesListType + " list",
            items: ecommerceItems
        }
    })
}

function trackCartPhone(phone, countryCode = '', email) {
    const normalizedPhone = getValidPhone(phone, countryCode);
    if (!normalizedPhone) {
        return;
    }

    trackCartUserInfo({phone: normalizedPhone}, email, normalizedPhone);
}


function trackCartEmail(email, phone, countryCode = '') {
    if (!isValidEmail(email)) {
        return;
    }

    trackCartUserInfo({email}, email, getValidPhone(phone, countryCode));
}

function trackCartUserInfo(ecommerce, email, phone) {
    trackEvent({
        event: 'user_info',
        ecommerce,
        user_data: {
            email_address: isValidEmail(email) ? email : undefined,
            phone_number: phone,
        },
    });
}

function getCurrentSubproduct(subproductId) {
    return currentSubproducts.find(function (subproduct) {
        return subproduct.service_id == subproductId;
    });
}

function getServiceFormData() {
    let formData = {};
    let serializedFormData = $('#serviceOrderForm').serializeArray();
    $(serializedFormData).each(function (index, obj) {
        formData[obj.name] = obj.value;
    });

    return formData;
}

function getValidPhone(phone, countryCode) {
    if (!phone || !countryCode) {
        return undefined;
    }

    const normalizedPhone = '+' + (countryCode + phone).replace(/\D/g, '');
    return /^\+\d{10,15}$/.test(normalizedPhone) ? normalizedPhone : undefined;
}

function isValidEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
}

module.exports = {
    trackSubProductSelection,
    trackAddToCart,
    queueAddToCart,
    trackViewItem,
    trackViewItemlist,
    trackCartPhone,
    trackCartEmail,
};
